/** 活动类型的默认调度配置；未知类型回退为不展示。 */

import type { IActivityDefaultEntry, TActivityPopupType, TDisplayTab, TKnownActivityPopupType } from './types';

/** 未知活动类型的兜底键 */
export const FALLBACK_ACTIVITY_TYPE = '__fallback__' as const;

/** 未知 type 兜底优先级（最低） */
export const PRIORITY_FALLBACK = 0;
/** 普通运营活动优先级 */
export const PRIORITY_DEFAULT = 1;
/** 支付相关弹窗优先级起点（越大越高） */
export const PRIORITY_PAYMENT_BASE = 10;

/** priority 越大越先；新增活动类型时在此补齐展示范围与调度规则。 */
export const ACTIVITY_DEFAULTS: Record<TKnownActivityPopupType | typeof FALLBACK_ACTIVITY_TYPE, IActivityDefaultEntry> =
    {
        // 会员取消挽留仅在付费墙展示。
        subscribe_retention: {
            priority: PRIORITY_PAYMENT_BASE + 2,
            tabs: ['paywall'],
            widgetTabs: [],
            mutexGroup: 'retention',
            blocksOthers: false,
            openWidgetOnDismiss: false,
        },
        // 展示期间排他；关闭后可转为挂件。
        recharge_retention: {
            priority: PRIORITY_PAYMENT_BASE + 2,
            tabs: ['home', 'paywall', 'mylist'],
            widgetTabs: ['home', 'mylist'],
            mutexGroup: 'retention',
            blocksOthers: true,
            openWidgetOnDismiss: true,
            widgetId: '0000002',
        },
        subscription_discount: {
            priority: PRIORITY_PAYMENT_BASE,
            tabs: ['home', 'paywall'],
            widgetTabs: ['home'],
            mutexGroup: 'discount',
            blocksOthers: false,
            openWidgetOnDismiss: true,
        },
        ops_promo: {
            priority: PRIORITY_DEFAULT,
            tabs: ['home'],
            widgetTabs: ['home'],
            mutexGroup: 'ops_promo',
            blocksOthers: false,
            openWidgetOnDismiss: true,
        },
        // 未适配类型不展示，避免服务端新增活动影响现有页面。
        [FALLBACK_ACTIVITY_TYPE]: {
            priority: PRIORITY_FALLBACK,
            tabs: [],
            widgetTabs: [],
            blocksOthers: false,
            openWidgetOnDismiss: false,
        },
    };

/**
 * 按活动 type 取默认调度项；未知 type 回退 __fallback__。
 * @param type 活动弹窗 / 挂件 type
 */
export function resolveActivityDefaults(type: TActivityPopupType): IActivityDefaultEntry {
    const knownTypes: TKnownActivityPopupType[] = [
        'subscribe_retention',
        'recharge_retention',
        'subscription_discount',
        'ops_promo',
    ];
    const matched = knownTypes.find(item => item === type);
    if (matched) {
        return ACTIVITY_DEFAULTS[matched];
    }
    return ACTIVITY_DEFAULTS[FALLBACK_ACTIVITY_TYPE];
}

export function resolveWidgetTabs(type: TActivityPopupType): TDisplayTab[] {
    return [...resolveActivityDefaults(type).widgetTabs];
}

export function resolveWidgetId(type: TActivityPopupType): string | undefined {
    return resolveActivityDefaults(type).widgetId;
}

/** 当前自动弹窗次数按整会话计数，包含付费墙挽留。 */
export const DEFAULT_MAX_PER_ENTRY = 1;
